import { g as get$1 } from './b6480678.mjs';
import { s as sendCustomRequest, a as dateNow } from './6cf04c83.mjs';
import { g as get } from './8326d31c.mjs';

const SAMESITE_VALUES = ["None", "Lax", "Strict"];

function exists(name) {
  const values = document.cookie.split(";");
  const reg = new RegExp(`^( )*${encodeURIComponent(name)}$`, "g");
  for (let i = 0; i < values.length; i += 1) {
    if (reg.test(values[i].split("=")[0])) {
      return true;
    }
  }
  return false;
}

function remove(name, options) {
  const opts = options || {};
  let optionsString = "";
  optionsString += ` path=${opts.path ? opts.path : "/"};`;
  if (opts.domain) {
    optionsString += ` domain=${opts.domain};`;
  }
  document.cookie = `${encodeURIComponent(
    name
  )}=;${optionsString} expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

function set(name, value, options) {
  let timeInMinutes = 60;
  const date = dateNow();
  const opts = options || {};
  let cookieString;
  if (opts.minutes) {
    timeInMinutes = opts.minutes;
  }
  if (opts.days) {
    if (!opts.minutes) {
      timeInMinutes = 0;
    }
    timeInMinutes += opts.days * 24 * 60;
  }
  date.setTime(date.getTime() + timeInMinutes * 60 * 1e3);
  cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  cookieString += `; expires=${date.toUTCString()}`;
  cookieString += `; path=${opts.path || "/"}`;
  if (opts.domain) {
    cookieString += `; domain=${opts.domain}`;
  }
  if (opts.samesite && SAMESITE_VALUES.includes(opts.samesite)) {
    cookieString += `; SameSite=${opts.samesite}`;
    if (opts.samesite === "None") {
      cookieString += `; Secure`;
    }
  }
  document.cookie = cookieString;
  if (get("LHAS_2048_TRACK_COOKIES", false)) {
    sendCustomRequest("o_util.cookie.set()", {
      cookiePath: options && options.path ? options.path : "/",
      cookieExpires: date.toUTCString(),
      cookieDomain: options && options.domain ? options.domain : -1,
      cookieName: name,
      cookieValue: value,
      cookieSameSite: options && options.samesite ? options.samesite : -1
    });
  }
}

var index = /*         */Object.freeze({
  __proto__: null,
  SAMESITE_VALUES: SAMESITE_VALUES,
  exists: exists,
  get: get$1,
  remove: remove,
  set: set
});

export { SAMESITE_VALUES as S, exists as e, index as i, remove as r, set as s };
/*                                 */
